import {
  EmailCredentialsOwnerType,
  SmtpCredentialsResponseBody,
  SmtpEmailProviderCode,
} from '@dms/api/core';

import {EmailServiceForm} from './EmailServiceForm';

interface UpdateEmailServiceProviderProps {
  credentials: SmtpCredentialsResponseBody;
  providerCode?: SmtpEmailProviderCode;
  ownerType: EmailCredentialsOwnerType;
}

export function UpdateEmailServiceProvider(props: UpdateEmailServiceProviderProps) {
  return (
    <EmailServiceForm
      providerCode={props.providerCode}
      defaultValues={{
        emailAddress: props.credentials.emailAddress,
        host: props.credentials.host,
        port: props.credentials.port,
        username: props.credentials.username,
        title: props.credentials.title,
      }}
      ownerType={props.ownerType}
      id={props.credentials.id}
    />
  );
}
